<template>
  <div class="complaint-page">
    <van-nav-bar fixed title="投诉反馈" left-text="返回" left-arrow @click-left="goBack" />

    <div class="complaint-body">
      <!-- 未登录提示 -->
      <div v-if="!isLogin" class="not-login">
        <van-icon name="warning-o" size="60" color="#ff6b35" />
        <p>请先登录后再提交投诉反馈</p>
        <van-button type="primary" round @click="$router.push('/login')">去登录</van-button>
      </div>

      <!-- 投诉表单 -->
      <div v-else class="complaint-form">
        <div class="form-card">
          <div class="form-title">投诉 / 反馈</div>
          <div class="form-label">投诉标题</div>
          <van-field
            v-model="form.title"
            placeholder="请输入投诉标题（必填）"
            maxlength="50"
            :border="false"
          />
          <div class="form-label">投诉内容</div>
          <van-field
            v-model="form.content"
            type="textarea"
            rows="5"
            maxlength="500"
            show-word-limit
            placeholder="请详细描述您遇到的问题（至少 5 个字）"
            :border="false"
          />
          <div class="form-label">联系方式</div>
          <van-field
            v-model="form.contact"
            placeholder="手机号 / 邮箱（选填，方便我们联系您）"
            maxlength="50"
            :border="false"
          />
          <div class="complaint-tip">
            提交后我们会在 1-3 个工作日内通过邮件回复处理结果
          </div>
        </div>

        <div class="submit-area">
          <van-button
            type="primary"
            block
            round
            :loading="submitting"
            :disabled="submitting"
            @click="submitComplaint"
          >提交投诉</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { submitComplaintApi } from '@/api/user'
import { Toast } from 'vant'

export default {
  name: 'Complaint',
  data () {
    return {
      submitting: false,
      form: {
        title: '',
        content: '',
        contact: ''
      }
    }
  },
  computed: {
    isLogin () {
      return !!this.$store.getters.token
    }
  },
  methods: {
    // 返回（无历史记录时回到个人中心）
    goBack () {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace('/user')
      }
    },
    async submitComplaint () {
      const f = this.form
      if (!f.title.trim()) {
        Toast('请输入投诉标题')
        return
      }
      if (f.content.trim().length < 5) {
        Toast('投诉内容至少 5 个字')
        return
      }
      this.submitting = true
      try {
        await submitComplaintApi({
          title: f.title.trim(),
          content: f.content.trim(),
          contact: f.contact.trim()
        })
        this.form = { title: '', content: '', contact: '' }
        Toast.success('投诉已提交，我们会尽快处理！')
        setTimeout(() => {
          this.$router.back()
        }, 1200)
      } catch (err) {
        Toast(typeof err === 'string' ? err : '提交失败，请稍后重试')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.complaint-page {
  min-height: 100vh;
  background: #f7f7f7;
  padding-top: 46px;
  padding-bottom: 30px;
  /deep/ .van-nav-bar__arrow { color: #333; }
  /deep/ .van-nav-bar__text { color: #333; }

  .complaint-body {
    padding: 16px;

    .not-login {
      text-align: center;
      padding: 80px 20px;

      p {
        color: #666;
        margin: 16px 0 24px;
        font-size: 15px;
      }
    }

    .form-card {
      background: #fff;
      border-radius: 12px;
      padding: 20px 16px;

      .form-title {
        font-size: 17px;
        font-weight: 600;
        text-align: center;
        margin-bottom: 16px;
        color: #1a1a2e;
      }

      .form-label {
        font-size: 13px;
        color: #666;
        margin: 14px 0 6px;
      }

      .complaint-tip {
        font-size: 12px;
        color: #999;
        margin-top: 14px;
        background: #f8f8f8;
        padding: 10px 12px;
        border-radius: 8px;
        line-height: 1.6;
      }
    }

    .submit-area {
      margin-top: 24px;

      .van-button {
        background: linear-gradient(90deg, #ecb53c, #ff9211);
        border: none;
      }
    }
  }
}
</style>
